import React from 'react';
import { useAuth } from '@/contexts/AuthContext';

function AppointmentsPage() {
  const { user } = useAuth();
  return (
    <div className="space-y-4" data-testid="appointments-page">
      <h2 className="text-3xl font-light tracking-widest uppercase">Κλείσε Ραντεβού</h2>

      {/* Elite Loyalty Info Banner */}
      <div className="border border-amber-700/30 bg-black/40 rounded p-3 flex items-center gap-2.5">
        <svg className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
        </svg>
        <p className="text-xs font-light tracking-wide" style={{ color: '#D4AF37' }}>
          Για πόντους Elite, χρησιμοποιήστε το ίδιο email στο Setmore
          {user?.email && <span className="text-white/90"> ({user.email})</span>}
        </p>
      </div>

      {/* Setmore embed — normal height, no internal scroll */}
      <div
        className="w-full overflow-hidden"
        style={{
          background: '#000',
          borderTop: '1px solid rgba(255,255,255,0.06)',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
        }}
      >
        <style>{`
          #setmore-frame {
            color-scheme: dark;
            filter: invert(0);
          }
        `}</style>
        <iframe
          id="setmore-frame"
          src="https://dimakas.setmore.com/"
          title="Κλείσιμο Ραντεβού"
          className="w-full"
          style={{
            height: '1200px',
            border: 'none',
            display: 'block',
            background: 'transparent',
          }}
          frameBorder="0"
          scrolling="no"
          data-testid="setmore-iframe"
        />
      </div>

      <p className="text-center text-gray-600 text-xs font-light tracking-widest">
        Χρησιμοποιήστε την παραπάνω φόρμα για να κλείσετε ραντεβού σας
      </p>
    </div>
  );
}

export default AppointmentsPage;
